export default __webpack_public_path__ + "static/media/rubymine.4f6ca5b7.svg";